<template>
  <div class="ma-1">
    <v-data-table
      :headers="headers"
      :items="desserts"
      :fixed-header="true"
      :search="search"
      class="elevation-3 font-resp-tabela altura-tabela table-full-screen"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cadastro de Releases Notes</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>

          <v-spacer></v-spacer>

          <v-text-field
            class="mr-10"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>

          <v-dialog persistent v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
            </template>

            <v-card>
              <v-card-title>
                <v-btn icon class="mr-3 ml-n2" @click="close()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text class="pa-4 mt-4">
                <v-container>
                  <v-row>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.versao"
                        label="Digite a versão do sistema*"
                        color="#042333"
                        item-text="versao"
                        item-value="versao"
                        :error-messages="versaoErrors"
                        @input="$v.editedItem.versao.$touch()"
                        @blur="$v.editedItem.versao.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="12" xs="12">
                      <v-textarea
                        outlined
                        v-model="editedItem.descricao"
                        label="Digite a descrição dessa versão*"
                        color="#042333"
                        item-text="descricao"
                        item-value="descricao"
                        :error-messages="descricaoErrors"
                        @input="$v.editedItem.descricao.$touch()"
                        @blur="$v.editedItem.descricao.$touch()"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close">fechar</v-btn>
                <v-btn color="primary" text @click="save">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.scr_modulo="{ item }">
        <v-icon>{{ item.scr_modulo }}</v-icon>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Módulo" class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon title="Remover Módulo" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import { required } from "vuelidate/lib/validators"
import ReleaseNoteAPI from "../../../api/releasesNotes"

export default {
  data: () => ({
    loading: true,
    dialog: false,
    atualizar: 0,
    search: "",
    editedIndex: -1,
    headers: [
      {text: "ID", value: "id",},
      {text: "Versão", value: "versao",},
      {text: "Descrição", value: "descricao" },
      { text: "Ações", value: "action", width: '80px', sortable: false },
      { text: "", value: "action_delete", sortable: false },
    ],
    desserts: [],
    selects: {
      release: {
        items: [],
      }
    },
    editedItem: {
      id: '',
      versao: localStorage.getItem('app_version'),
      descricao: ""
    },
    defaultItem: {
      id: "",
      versao: localStorage.getItem('app_version'),
      descricao: "",
    },
  }),
  validations: {
    editedItem: {
      versao: {
        required,
        jaCadastrada() {
          return !this.versaoJaCadastrada;
        }
      },
      descricao: {
        required
      },
    },
  },

  computed: {
    versaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.versao.$dirty) return errors;
      !this.$v.editedItem.versao.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.versao.jaCadastrada && errors.push("Versão já cadastrada!");

      return errors;
    },
     descricaoErrors() {
      const errors = [];
        if (!this.$v.editedItem.descricao.$dirty) return errors;
        !this.$v.editedItem.descricao.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Release Note" : "Editar Release Note";
    },
    versaoJaCadastrada () {
      if (!this.desserts || this.desserts.length === 0 || !this.editedItem.versao || this.editedItem.id){
        return false
      }

      const existe = this.desserts.filter(item => item.versao == this.editedItem.versao.trim())

      return existe.length > 0
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      ReleaseNoteAPI.getReleaseNotes(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.desserts = response.data.release;
          }
          this.loading = false
        })
        .catch(() => {
          this.Helpers.logout();
        });

        this.$store.dispatch("loading/habilitarLoading", false);
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true
    },
    deleteItem(item) {
      if (confirm("Deseja remover esta release note?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = { id: item.id };

        this.$store.dispatch(
          "loading/addRequisicao",
          ReleaseNoteAPI.deleteReleaseNotes(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
          .catch(() => {
            this.Helpers.logout();
          })
        );
      }
    },
    close() {
      this.dialog = false;
      this.$v.$reset(); // Resetar validação
      this.editedItem = this.defaultItem
    },
    save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = this.editedItem

        this.$store.dispatch(
          "loading/addRequisicao",
          ReleaseNoteAPI.addNovaReleaseNote(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.close();

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
  },
};
</script>
